import { Notifications as NotificationsIcon } from '@mui/icons-material';
import { Badge, IconButton } from '@mui/material';
import { useRef, useState } from 'react';

import { useNotificationLiveUpdates, useUnreadCount } from '@/hooks/useNotifications';
import { bellBadgeLabel } from './bellBadge';
import { NotificationPanel } from './NotificationPanel';

interface NotificationBellButtonProps {
  color?: 'inherit' | 'default';
}

export function NotificationBellButton({ color = 'default' }: NotificationBellButtonProps) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);
  const { data: count = 0 } = useUnreadCount();
  useNotificationLiveUpdates(true);

  const label = bellBadgeLabel(count);

  return (
    <>
      <IconButton
        ref={anchorRef}
        color={color}
        onClick={() => setOpen(true)}
        aria-label={count > 0 ? `notifications, ${label} unread` : 'notifications'}
      >
        <Badge badgeContent={label} color="error" invisible={count <= 0}>
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationPanel open={open} anchorEl={anchorRef.current} onClose={() => setOpen(false)} />
    </>
  );
}
